/**
 * @generated SignedSource<<f950e529450f6d326427bbfcbb1c5bc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATUserOrganizationCreateInput = {
  organization: string;
  realname?: string | null;
  user: string;
};
export type MATUserOrganizationCreateDialog_userOrganizationCreateMutation$variables = {
  input: MATUserOrganizationCreateInput;
};
export type MATUserOrganizationCreateDialog_userOrganizationCreateMutation$data = {
  readonly userOrganizationCreate: {
    readonly id: string;
  };
};
export type MATUserOrganizationCreateDialog_userOrganizationCreateMutation = {
  response: MATUserOrganizationCreateDialog_userOrganizationCreateMutation$data;
  variables: MATUserOrganizationCreateDialog_userOrganizationCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATUserOrganization",
    "kind": "LinkedField",
    "name": "userOrganizationCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATUserOrganizationCreateDialog_userOrganizationCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATUserOrganizationCreateDialog_userOrganizationCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3a39feaf37721435af6b3fa75f344212",
    "id": null,
    "metadata": {},
    "name": "MATUserOrganizationCreateDialog_userOrganizationCreateMutation",
    "operationKind": "mutation",
    "text": "mutation MATUserOrganizationCreateDialog_userOrganizationCreateMutation(\n  $input: MATUserOrganizationCreateInput!\n) {\n  userOrganizationCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "99a0b79d2d8ca02541a7fdbd18055ccc";

export default node;
